export enum AccountTypeEnum {
    AUT = 'AUT', //AUTHOR
    AGE = 'AGE', //AUTHOR'S AGENT
    PUB = 'PUB', // PUBLISHER
    REV = 'REV', // REVIEWER
    AGENCY = 'AGENCY'
}
